import { OnFilterCatalog } from './catalog.types'

export const FILTER_CATALOG = 'FILTER_CATALOG'

export const onFilterCatalog: OnFilterCatalog = filteringInfos => ({
  payload: filteringInfos,
  type: FILTER_CATALOG
})
